export default __webpack_public_path__ + "static/media/pago-contraentrega.2a5808d1.svg";